/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';

import connectData, { ConnectedProps } from '../../support/connectData';
import FormBuilderActions from '../../support/FormBuilderActions';

import CheckboxList, { CheckboxItem } from '../uiold/CheckboxListOld';
import Editor, { EditorContent } from '../../core-ui/Editor/StatefulEditor';
import Checkbox from '../uiold/CheckboxOld';
import Radio from '../uiold/Radio';
import { canUser } from '../../support/shared/permissionHelpers';
import NoPermissionMessage from '../Users/WritePermissionMessage';

import {
  Button,
  Card,
  CurrencyInput,
  Page,
  PercentInput,
  Text,
  TextInput,
} from '../uiold';
import Infotip from '../uiold/Infotip';

import { Account } from '../../types/shared/Account';

type FormDef = ObjectOf<any>;

class FormOptions extends Component<FullProps> {
  render() {
    let { formDef, account, isDirty, isLoading, user } = this.props;
    return (
      <Page isLoading={!formDef || !account || isLoading}>
        <Page.Header title="Form Options">
          {isDirty && user && canUser(user, { formBuilder: 'WRITE' }) ? (
            <Button
              title="Save Changes"
              isPrimary
              onPress={this.props.saveFormDef}
            />
          ) : (
            isDirty && <NoPermissionMessage />
          )}
        </Page.Header>
        {formDef && account && (
          <Card style={styles.cardStyle}>
            {this._renderFormName(formDef)}
            {this.renderFormVisibility(formDef)}
            {this._renderAllowRenewal(formDef)}
            {this._renderDisplayPrice(formDef)}

            {this._renderPaymentFormOption(formDef, account)}
            {this._renderPaymentFeeOption(formDef, account)}

            {this._renderShowBeforeForm(formDef)}
            {this._renderShowAfterSubmit(formDef)}
            {this._renderThankYouEmail(formDef)}
            {this._renderAdminNotification()}
            {this._renderPublicFields(formDef)}
            {this._renderFilterFields(formDef)}
          </Card>
        )}
      </Page>
    );
  }

  _renderFormName = (formDef: FormDef) => {
    let { user } = this.props;
    let canEdit = user && canUser(user, { formBuilder: 'WRITE' });
    return (
      <View style={styles.contentField}>
        <View style={styles.titleDiv}>
          <Text style={styles.fieldTitle}>Form Name</Text>
        </View>
        <TextInput
          placeholder="name"
          disabled={!canEdit}
          autoFocus={true}
          value={formDef.name}
          onChangeText={(text) => {
            this._onValueChange('name', text);
          }}
        />
      </View>
    );
  };

  renderFormVisibility = (formDef: FormDef) => {
    let { user } = this.props;
    let canEdit = user && canUser(user, { formBuilder: 'WRITE' });
    return (
      <View style={styles.contentField}>
        <View style={styles.titleDiv}>
          <Text style={styles.fieldTitle}>Form visible to public</Text>
        </View>
        <View style={styles.radioRow}>
          <View style={styles.radioChild}>
            <Radio
              value={true}
              checked={!!formDef.enabled}
              onChange={(value: any) => {
                canEdit && this._onValueChange('enabled', value);
              }}
            />
            <Text>Yes</Text>
          </View>
          <View style={styles.radioChild}>
            <Radio
              value={false}
              checked={!formDef.enabled}
              onChange={(value: any) => {
                canEdit && this._onValueChange('enabled', value);
              }}
            />
            <Text>No</Text>
          </View>
        </View>
      </View>
    );
  };

  _renderAllowRenewal = (formDef: FormDef) => {
    let { user } = this.props;
    let canEdit = user && canUser(user, { formBuilder: 'WRITE' });
    return (
      <View style={styles.contentField}>
        <View style={styles.titleDiv}>
          <Text style={styles.fieldTitle}>
            Allow Renewal{' '}
            <Infotip text="Renewals only go back one archived season." />
          </Text>
        </View>
        <View style={styles.radioRow}>
          <View style={styles.radioChild}>
            <Radio
              value={true}
              checked={formDef.allow_renewal === true}
              onChange={(value: any) => {
                canEdit && this._onValueChange('allow_renewal', value);
              }}
            />
            <Text>Yes</Text>
          </View>
          <View style={styles.radioChild}>
            <Radio
              value={false}
              checked={!formDef.allow_renewal}
              onChange={(value: any) => {
                canEdit && this._onValueChange('allow_renewal', value);
              }}
            />
            <Text>No</Text>
          </View>
        </View>
      </View>
    );
  };

  _renderDisplayPrice = (formDef: FormDef) => {
    let { user } = this.props;
    let canEdit = user && canUser(user, { formBuilder: 'WRITE' });
    return (
      <View style={styles.contentField}>
        <View style={styles.titleDiv}>
          <Text style={styles.fieldTitle}>Display Price on Signup Form</Text>
        </View>
        <View style={styles.radioRow}>
          <View style={styles.radioChild}>
            <Radio
              name="display_price"
              value={true}
              onChange={(value: any) => {
                canEdit && this._onValueChange('display_price', value);
              }}
              checked={formDef.display_price === true}
            />
            <Text>Yes</Text>
          </View>
          <View style={styles.radioChild}>
            <Radio
              name="display_price"
              value={false}
              onChange={(value: any) => {
                canEdit && this._onValueChange('display_price', value);
              }}
              checked={!formDef.display_price}
            />
            <Text>No</Text>
          </View>
        </View>
      </View>
    );
  };

  _renderShowBeforeForm = (formDef: FormDef) => {
    let { user } = this.props;
    let canEdit = user && canUser(user, { formBuilder: 'WRITE' });
    return (
      <View style={styles.contentField}>
        <View style={styles.titleDiv}>
          <Text style={styles.fieldTitle}>Show Before Form</Text>
        </View>
        <View style={styles.editorDiv}>
          <Text>
            {this._renderCheckbox('show_preamble')} Display an acknowledgement
            before showing this form
          </Text>
          <View style={styles.editorArea}>
            {formDef.show_preamble ? (
              <Editor
                readOnly={!canEdit}
                height={280}
                initialContent={formDef.preamble_content || ''}
                onChange={(value) => {
                  this._onEditorValueChange('preamble_content', value);
                }}
              />
            ) : null}
          </View>
        </View>
      </View>
    );
  };

  _renderShowAfterSubmit = (formDef: FormDef) => {
    let { user } = this.props;
    let canEdit = user && canUser(user, { formBuilder: 'WRITE' });
    return (
      <View style={styles.contentField}>
        <View style={styles.titleDiv}>
          <Text style={styles.fieldTitle}>Show After Submit</Text>
        </View>
        <View style={styles.editorDiv}>
          <Text>Show the following content after successful form submit</Text>
          <View style={styles.editorArea}>
            <Editor
              height={280}
              readOnly={!canEdit}
              initialContent={formDef.post_submit_content || ''}
              onChange={(value) => {
                this._onEditorValueChange('post_submit_content', value);
              }}
            />
          </View>
        </View>
      </View>
    );
  };

  _renderThankYouEmail = (formDef: FormDef) => {
    let { user } = this.props;
    let canEdit = user && canUser(user, { formBuilder: 'WRITE' });
    return (
      <View style={styles.contentField}>
        <View style={styles.titleDiv}>
          <Text style={styles.fieldTitle}>Thank You Email</Text>
        </View>
        <View style={styles.editorDiv}>
          <Text>
            {this._renderCheckbox('send_post_submit_email')} Email the applicant
            after successful form submit
          </Text>

          {formDef.send_post_submit_email ? (
            <View>
              <View style={styles.editorArea}>
                <TextInput
                  disabled={!canEdit}
                  onChangeText={(text) => {
                    this._onValueChange('post_submit_email_subject', text);
                  }}
                  value={formDef.post_submit_email_subject}
                  placeholder="Subject"
                />
              </View>
              <Text
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Text>Content</Text>
              </Text>
              <View style={styles.editorArea}>
                <Editor
                  readOnly={!canEdit}
                  height={280}
                  initialContent={formDef.post_submit_email_content}
                  onChange={(value) => {
                    this._onEditorValueChange(
                      'post_submit_email_content',
                      value,
                    );
                  }}
                />
              </View>
            </View>
          ) : null}
        </View>
      </View>
    );
  };

  _renderAdminNotification = () => {
    return (
      <View style={styles.contentField}>
        <View style={styles.titleDiv}>
          <Text style={styles.fieldTitle}>Admin Notification:</Text>
        </View>
        <View style={styles.radioChild}>
          <Text>
            {this._renderCheckbox('admin_notify')} Notify the administrator
            after each successful form submit
          </Text>
        </View>
      </View>
    );
  };

  _renderPublicFields = (formDef: FormDef) => {
    return (
      <View style={styles.contentField}>
        <View style={styles.titleDiv}>
          <Text style={styles.fieldTitle}>Public Fields</Text>
        </View>
        <View style={styles.editorDiv}>
          <Text>
            Select which form fields will be visible in the applicant’s Public
            Profile.
          </Text>
          <CheckboxList
            onSelectionChange={(value) => {
              this._onPublicFieldsChange(value);
            }}
          >
            {this._renderPublicItem(formDef)}
          </CheckboxList>
        </View>
      </View>
    );
  };

  _renderPublicItem = (formDef: FormDef) => {
    let fields = formDef.fields.toArray();
    // Filter out non-input fields
    fields = fields.filter((field: any) => field.definition.name != null);
    return this._renderCheckboxItems(fields);
  };

  _renderFilterFields = (formDef: FormDef) => {
    return (
      <View style={styles.contentField}>
        <View style={styles.titleDiv}>
          <Text style={styles.fieldTitle}>
            Filter Fields (for market locations feature only)
          </Text>
        </View>
        <View style={styles.editorDiv}>
          <Text>Select which form fields can be used to filter profiles.</Text>
          <CheckboxList
            onSelectionChange={(value) => {
              this._onFilterFieldsChange(value);
            }}
          >
            {this._renderFilterItems(formDef)}
          </CheckboxList>
        </View>
      </View>
    );
  };

  _renderFilterItems = (formDef: FormDef) => {
    let fields = formDef.fields.toArray().filter((field: any) => {
      // Filter out non-multichoice fields
      return (
        field.definition.type === 'MultichoiceElement' ||
        field.definition.type === 'BooleanElement'
      );
    });
    let filterFields = new Set(formDef.filter_fields || []);
    return fields.map((field: any) => {
      return (
        <CheckboxItem key={field.id} isChecked={filterFields.has(field.id)}>
          {field.definition.name}
        </CheckboxItem>
      );
    });
  };

  _renderPaymentFormOption = (formDef: FormDef, account: Account) => {
    let { linked_accounts: linkedAccounts } = account;
    if (linkedAccounts == null) {
      return;
    }
    let { stripe, paymentSpring } = linkedAccounts;
    let paymentSpringEnabled =
      !!paymentSpring?.private_api_key && !!paymentSpring?.public_api_key;
    let { user } = this.props;
    let canEdit = user && canUser(user, { formBuilder: 'WRITE' });
    if (!stripe && !paymentSpringEnabled) {
      return;
    }
    let stripeRadio = (
      <View style={styles.radioChild}>
        <Radio
          style={{ marginLeft: '10px' }}
          name="payment_on_submit"
          value="STRIPE"
          onChange={(value: any) => {
            canEdit && this._onValueChange('payment_on_submit', value);
          }}
          checked={formDef.payment_on_submit === 'STRIPE'}
        />
        <Text>Using Stripe</Text>
      </View>
    );
    let paymentSpringRadio = (
      <View style={styles.radioChild}>
        <Radio
          style={{ marginLeft: '10px' }}
          name="payment_on_submit"
          value="PAYMENTSPRING"
          onChange={(value: any) => {
            canEdit && this._onValueChange('payment_on_submit', value);
          }}
          checked={formDef.payment_on_submit === 'PAYMENTSPRING'}
        />
        <Text>Using PaymentSpring</Text>
      </View>
    );

    return (
      <View style={styles.contentField}>
        <View style={styles.titleDiv}>
          <Text style={styles.fieldTitle}>Accept Payment on submission:</Text>
        </View>

        <View style={styles.radioRow}>
          <View style={styles.radioChild}>
            <Radio
              name="payment_on_submit"
              value={null}
              onChange={(value: any) => {
                this._onValueChange('payment_on_submit', value);
              }}
              checked={formDef.payment_on_submit == null}
            />
          </View>
          <Text> Disabled</Text>
          {stripe && stripeRadio}
          {paymentSpringEnabled && paymentSpringRadio}
        </View>
      </View>
    );
  };

  _renderPaymentFeeOption = (formDef: FormDef, account: Account) => {
    let { linked_accounts: linkedAccounts } = account;
    let { user } = this.props;
    let canEdit = user && canUser(user, { formBuilder: 'WRITE' });
    let { feeOption, feeValue } = formDef;
    if (linkedAccounts == null) {
      return;
    }
    let { stripe, paymentSpring } = linkedAccounts;
    let paymentSpringEnabled =
      !!paymentSpring?.private_api_key && !!paymentSpring?.public_api_key;
    if (!stripe && !paymentSpringEnabled) {
      return;
    }
    let input;
    let accountCurrency =
      (account.settings && account.settings.currency) || 'USD';
    switch (feeOption) {
      case 'fixed':
        input = (
          <CurrencyInput
            disabled={!canEdit}
            accountCurrency={accountCurrency}
            onChange={this._onNumberChange}
            defaultValue={this._validatePrice(feeValue) || 0}
          />
        );
        break;
      case 'percentage':
      default:
        input = (
          <PercentInput
            disabled={!canEdit}
            onChange={this._onNumberChange}
            defaultValue={this._validatePrice(feeValue) || 100}
          />
        );
        break;
    }
    return (
      <View style={styles.contentField}>
        <View style={styles.titleDiv}>
          <Text style={styles.fieldTitle}>Fee on Payment Form:</Text>
        </View>
        <View style={styles.radioRow}>
          <View style={styles.radioChild}>
            <Radio
              name="feeOption"
              value="percentage"
              onChange={(value: any) => {
                canEdit && this._onFeeOptionChange(value);
              }}
              checked={!feeOption || feeOption === 'percentage'}
            />
            <Text>Percentage</Text>
          </View>
          <View style={styles.radioChild}>
            <Radio
              name="feeOption"
              value="fixed"
              onChange={(value: any) => {
                canEdit && this._onFeeOptionChange(value);
              }}
              checked={feeOption === 'fixed'}
            />
            <Text>Fixed</Text>
          </View>
        </View>
        <View style={styles.titleDiv}>{input}</View>
      </View>
    );
  };

  _renderCheckboxItems = (
    fields: Array<{
      definition: {
        [key: string]: any;
      };
      id: string;
    }>,
  ) => {
    return fields.map((field) => {
      let definition = field.definition;
      return (
        <CheckboxItem key={field.id} isChecked={definition.is_public}>
          {definition.name}
        </CheckboxItem>
      );
    });
  };

  _renderCheckbox = (fieldName: string) => {
    let { user } = this.props;
    let canEdit = user && canUser(user, { formBuilder: 'WRITE' });
    let formDef: any = this.props.formDef;
    return (
      <Checkbox
        disabled={!canEdit}
        onChange={(value) => this._onValueChange(fieldName, value)}
        checked={formDef?.[fieldName]}
      />
    );
  };

  _onPublicFieldsChange = (publicFields: Set<string>) => {
    let { formDef, user } = this.props;
    let canEdit = user && canUser(user, { formBuilder: 'WRITE' });
    if (!canEdit || !formDef) {
      return;
    }
    let newFields = formDef.fields.map((field: any) => {
      return field.update({ is_public: publicFields.has(field.id) });
    });
    FormBuilderActions.updateForm(formDef as any, 'fields', newFields);
  };

  _onFilterFieldsChange = (filterFields: Set<string>) => {
    let { user, formDef } = this.props;
    let canEdit = user && canUser(user, { formBuilder: 'WRITE' });
    if (!canEdit) {
      return;
    }
    FormBuilderActions.updateForm(
      formDef as any,
      'filter_fields',
      Array.from(filterFields),
    );
  };

  _onValueChange = (fieldName: string, value: any) => {
    let { user, formDef } = this.props;
    let canEdit = user && canUser(user, { formBuilder: 'WRITE' });
    if (!canEdit) {
      return;
    }
    FormBuilderActions.updateForm(formDef as any, fieldName, value);
  };

  _onFeeOptionChange = (option: string) => {
    let { formDef } = this.props;
    FormBuilderActions.updateFeeOption(
      formDef as any,
      option,
      option === 'fixed' ? 0 : 100,
    );
  };

  _onEditorValueChange = (fieldName: string, editorContent: EditorContent) => {
    let { formDef } = this.props;
    FormBuilderActions.updateForm(
      formDef as any,
      fieldName,
      editorContent.toString(),
    );
  };

  _validatePrice = (price: number) => (price < 0 ? 0 : price);

  _onNumberChange = (value: number) => {
    let { formDef } = this.props;
    if (!Number.isNaN(Number(value))) {
      FormBuilderActions.updateForm(
        formDef as any,
        'feeValue',
        this._validatePrice(value),
      );
    }
  };
}

let styles = StyleSheet.create({
  cardStyle: {
    paddingVertical: 30,
    paddingHorizontal: 60,
  },
  contentField: {
    padding: 10,
  },
  titleDiv: {
    paddingVertical: 10,
  },
  fieldTitle: {
    fontWeight: '600',
  },
  radioRow: {
    flexDirection: 'row',
  },
  radioChild: {
    flexDirection: 'row',
    paddingRight: 10,
  },
  editorDiv: {
    left: 0,
    right: 0,
  },
  editorArea: {
    paddingVertical: 10,
  },
});

const connector = connectData()(
  () => ({
    account: { dataStoreKey: 'account' },
    user: { dataStoreKey: 'user' },
    formDef: {
      dataStoreKey: 'forms/:id',
      params: ['signup'],
    },
  }),
  () => ({
    saveFormDef: {
      dataStoreKey: 'forms/:id',
      params: ['signup'],
    },
  }),
);
type FullProps = ConnectedProps<typeof connector>;
export default connector(FormOptions);
